module.exports = __webpack_public_path__ + "static/earthbg-0be1715e465f537b84d3d49e8652181c.svg";